import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    Programas: [],
};

export const registroProgramasSlice = createSlice({
    name: "Programas",
    initialState,
    reducers: {
        agregarProgramas: (state, action) => {
            // Check if the payload is an array or a single item
            const newItems = Array.isArray(action.payload) ? action.payload : [action.payload];

            // Filter out duplicates
            const existingProgramasIds = new Set(state.Programas.map(programa => programa.id));
            const filteredNewItems = newItems.filter(item => !existingProgramasIds.has(item.id));

            // Update state with filtered items
            state.Programas = [...state.Programas, ...filteredNewItems];
        },
    },
});

export const { agregarProgramas } = registroProgramasSlice.actions;

export default registroProgramasSlice.reducer;
